<template>
  <div class="modal" data-backdrop="static" id="bsMediaRateCardSaveFormDialog" ref="bsMediaRateCardSaveFormDialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content viewDetails">
        <form name="saveMediaRateCard"
              :action="pUrls['saveMediaRateCard']"
              method="post" class="ajax-support show-waiting"
              data-ajax-support-csv="#ajaxModuleForm,#mediaRateCardListHeader,#mediaRateCardListBody,#mediaRateCardViewBody">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span>
            </button>
            <h3 class="modal-title">{{ title }}</h3>
          </div>
          <div class="modal-body max-height fileupload-dropzone bs3-padding-top-reset bs3-padding-bottom-reset overflow-y-hidden"
               style="overflow-y: hidden;">

            <input type="hidden" name="dataForm.data.id" :value="data.id"/>

            <input type="hidden" name="src" :value="pSrc"/>
            <input type="hidden" name="srcId" :value="pSrcId"/>

            <div v-if="nbOfErrors > 0">
              <div class="bs3-padding text-center bs3-margin-left-minus15 bs3-margin-right-minus15 bg-danger">
                <span class="label label-danger">{{ nbOfErrors | error(pDictionary) }}</span>
              </div>
            </div>

            <div class="bs3-padding-y">
                <!--
                 - NAME
                 --->
                <div :class="['form-group', {'has-error': hasFieldErrors('dataForm.data.name')}]">
                  <div v-if="hasFieldErrors('dataForm.data.name')">
                    <span v-for="error in getFieldErrors('dataForm.data.name')" class="help-block" :key="error">{{ error }}</span>
                  </div>
                  <label v-else for="mediaRateCard_Name">
                    <span class="required">*</span> {{ pDictionary['dictionary.media.rate.card.name'] }}
                  </label>
                  <input type="text"
                         id="mediaRateCard_Name"
                         :name="'dataForm.data.name'"
                         v-model="data.name"
                         class="form-control"
                         :placeholder="pDictionary['dictionary.media.rate.card.name.placeholder']"/>
                </div>
            </div>

          </div>
          <div class="modal-footer">
            <div class="text-right">
              <button type="submit" class="btn btn-primary">
                <i class="fa-light fa-check"></i> <span>{{ pDictionary['dictionary.actions.save'] }}</span>
              </button>
              <a href="#"
                 class="btn btn-link" data-dismiss="modal" aria-label="Cancel">{{ pDictionary['dictionary.actions.cancel'] }}</a>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import stringhelpers from "@/helpers/string-helpers";

export default {
  name: "MediaRateCardSaveForm",
  props: {
    pCurrencies: Array,
    pLanguage: String,
    pDictionary: Object,
    pUrls: Object,
    pErrorList: {
      type: Object,
      default: function () {
        return {}
      }
    },
    pSrc: String,
    pSrcId: String,
    pDataForm: Object
  },
  data: function () {
    return {
      data: this.pDataForm.data,
      errorList: []
    }
  },
  methods: {
    isIdValid: function () {
      return this.data.id !== undefined
             && this.data.id > 0;
    },
    hasFieldErrors: function (name) {
      if(name in this.pErrorList)
      {
        return !$.isEmptyObject(this.pErrorList[name]);
      }
    },
    getFieldErrors: function (name) {
      if(name in this.pErrorList)
      {
        return this.pErrorList[name];
      }
      return [];
    }
  },
  computed: {
    title: function () {
      return this.isIdValid()
             ? this.pDictionary['dictionary.media.rate.card.udate.title']
             : this.pDictionary['dictionary.media.rate.card.create.title'];
    },
    nbOfErrors: function () {
      return Object.keys(this.pErrorList).length;
    }
  },
  filters: {
    // TODO: Use mixin...
    i18nparams: function (text, index, param) {
      if(!text)
      {
        return text;
      }
      else
      {
        return stringhelpers.replaceAll(text, '__' + index + '__', param);
      }
    },
    money: function (value, currencies, currencyId) {
      if(value) {
        let currency = currencies.find(c => c.id === currencyId);
        if(currency) {
          if(currency.symbolPosition === 'BEFORE') {
            return currency.symbol + " " + value;
          }
          return value + " " + currency.symbol;
        }
      }
      return '-';
    },
    percent: function (value, dictionary) {
      if(!value)
      {
        return '-';
      }
      else
      {
        let percentFormat = dictionary['dictionary.format.percent.digit.4'];
        return stringhelpers.replaceAll(percentFormat, '__0__', value);
      }
    },
    error: function (value, dictionary) {
      if(!value)
      {
        return '-';
      }
      else
      {
        let errorFormat = dictionary['dictionary.general.errors'];
        return stringhelpers.replaceAll(errorFormat, '__0__', value);
      }
    }
  },
  mounted: function () {
    let _component = this;

    let $bsMediaRateCardSaveFormDialog = $(this.$refs.bsMediaRateCardSaveFormDialog);
    $bsMediaRateCardSaveFormDialog.on('shown.bs.modal', function () {

    });

    $bsMediaRateCardSaveFormDialog.on('hidden.bs.modal', function () {

    });

    $(_component.$refs.bsMediaRateCardSaveFormDialog).modal();
  }
}
</script>

<style scoped>

</style>